exports.default = {
  'agent_center': 'Agents Hub',
  'create_agent': 'New Agent',
  'search_results': 'Search results for {keyword}',
  'found_agents': '({count} agents found)',
  'no_search_results': 'No results found. Try a different search term.',
  'relevance': 'Relevance',
  'most_popular': 'Most Popular',
  'latest_released': 'Latest Released',
  'i_created': 'My Agents',
  'recommended': 'Recommended',
  'your_agents': 'Your Agents',
  'loading': 'Loading',
  'no_more': 'No More',
  'settings': 'Settings',
  'delete': 'Delete',
  'confirm_delete_agent': 'Confirm delete agent?',
  'delete_agent_warning': 'Deleting an agent cannot be undone. Users will not be able to access your agent, and all prompt configurations and logs will also be deleted.',
  'subscription_incomplete': 'Subscription incomplete, please check your bill later',
  'order_cancelled': 'Order cancelled',
  'no_custom_agents': 'No Custom AI Agents'
}
